import { menuComedorSede, menuComedorReady, menuComedorOnInit, menuComedorSedeSelected } from './../../store/menu-comedor/menu-comedor.selectors';
import { MenuComedorState } from './../../store/menu-comedor/menu-comedor.reducers';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MENU_COMEDOR_OPCIONES, MENU_COMEDOR_SEDE, MENU_COMEDOR_TITLES, MENU_COMEDOR_TURNO, MENU_SEDE_TITLES, MENU_COMEDOR_TURNO_TITLES, MenuComedor, MenuComedorSedeRecord, MenuComedorTitle, MENU_SUGERENCIAS } from 'src/common/menuComedor';
import { Store } from '@ngrx/store';
import { TimeUtils } from 'src/common/timeUtils';
import { Observable, Subscription, combineLatest, filter, first, tap } from 'rxjs';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { menuComedorRequested, menuComedorSedeChanged as menuComedorSedeChanged } from '../../store/menu-comedor/menu-comedor.actions';
import { CENTRAL_SEDE_TYPE, SAN_JUSTO_SEDE_TYPE, sessionSedeType } from 'src/app/session/store/session.selectors';

@Component({
	selector: 'menu-comedor',
	templateUrl: './menu-comedor.component.html',
	styleUrls: ['./menu-comedor.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MenuComedorComponent implements OnInit {

	readonly BUENOS_AIRES_TAB_ID: string = MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.BUENOS_AIRES ];
	readonly SAN_JUSTO_TAB_ID: string = MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.SAN_JUSTO ];
	readonly ALMUERZO: string = MENU_COMEDOR_TURNO[ MENU_COMEDOR_TURNO.A ];

	activeNavId: string = this.BUENOS_AIRES_TAB_ID;
	menusSede$: Observable<( sede: MENU_COMEDOR_SEDE ) => MenuComedorSedeRecord>;
	menuReady$: Observable<boolean>;
	onInit$: Observable<boolean>;
	sedeSelected: string;
	private sedeSelectedSubscription: Subscription;
	readonly MENU_COMEDOR_OPCIONES: string[] = MENU_COMEDOR_OPCIONES;
	readonly MENU_COMEDOR_SEDES: string[] = Object.keys( MENU_COMEDOR_SEDE ).filter( sede => isNaN( Number( sede ) ) ).map( sede => sede.toString() );
	readonly MENU_SEDE_TITLES: {[k:string]: string} = MENU_SEDE_TITLES;
	readonly MENU_COMEDOR_TITLES: MenuComedorTitle = MENU_COMEDOR_TITLES;
	readonly MENU_COMEDOR_TURNO_TITLES: {[k:string]: string} = MENU_COMEDOR_TURNO_TITLES;
	readonly MENU_SUGERENCIAS: {[k:string]: string } = MENU_SUGERENCIAS;

	
	constructor( private store: Store<MenuComedorState>, private timeUtils: TimeUtils ) {
	}

	ngOnInit() {
		this.menusSede$ = this.store.select( menuComedorSede );
		this.menuReady$ = this.store.select( menuComedorReady );
		this.onInit$ = this.store.select( menuComedorOnInit );
		combineLatest([ this.store.select( sessionSedeType ), this.store.select( menuComedorSedeSelected ) ]).pipe(
			filter( ([ sedeType, sedeSelected ]) => sedeType != null ),
			first(),
			tap( ([ sedeType, sedeSelected ]) => {
				if( !sedeSelected ) {
					let sedeEnum: MENU_COMEDOR_SEDE;
					switch( sedeType ) {
						case CENTRAL_SEDE_TYPE:
							sedeEnum = MENU_COMEDOR_SEDE.BUENOS_AIRES;
							break;
						case SAN_JUSTO_SEDE_TYPE:
							sedeEnum = MENU_COMEDOR_SEDE.SAN_JUSTO;
							break;
						default:
							sedeEnum = MENU_COMEDOR_SEDE.BUENOS_AIRES;
							break;
					}
					this.store.dispatch( menuComedorSedeChanged( { sedeSelected: sedeEnum } ) );
					sedeSelected = MENU_COMEDOR_SEDE[ sedeEnum ];
				}

				this.sedeSelected = sedeSelected;
			})
		).subscribe();
		this.store.dispatch( menuComedorRequested() );
	}

	public isMenuEmpty( menu: MenuComedor ): boolean {
		let result: boolean = true;
		if( menu != null ) {
			MENU_COMEDOR_OPCIONES.forEach( function( key ) {
				result = result && ( menu[key] == null || menu[key].length == 0 );
			});
		}
		return result;
	}

	public onRefreshMenu(): void {
		this.store.dispatch( menuComedorRequested() );
	}

	public onNavChanged( event: NgbNavChangeEvent ): void {
		let sede: string = event.nextId;
		this.store.dispatch( menuComedorSedeChanged( { sedeSelected: MENU_COMEDOR_SEDE[ sede ] } ) );
	}

}
